import {AiOutlineInstagram} from 'react-icons/ai'
import {AiOutlineTwitter} from 'react-icons/ai'
// import {AiOutlineDribbble} from 'react-icons/ai'
import {AiFillFacebook} from 'react-icons/ai'
// import {AiFillGithub} from 'react-icons/ai'
import {AiFillLinkedin} from 'react-icons/ai'
import {FaWhatsapp} from 'react-icons/fa'
import { FaTiktok } from "react-icons/fa";


const data = [
    {id: 4, link: 'https://wa.me/+442034758219', icon: <FaWhatsapp/>},
    {id: 1, link: 'https://www.linkedin.com/company/skill-bridge-intelligence/', icon: <AiFillLinkedin/>},
    {id: 2, link: 'https://www.instagram.com/skillbridge.intelligence/', icon: <AiOutlineInstagram/>},
    {id: 3, link: 'https://www.tiktok.com/@skillbridge.intelligence', icon: <FaTiktok/>},
    // {id: 5, link: 'https://github.com', icon: <AiFillGithub/>}

]

export default data